import { validateTidalLicense } from "../../base/index.js";
import { coverageRootId, TIDAL_TELEMETRY } from "./constants.js";
import { telemetryEngine } from "./telemetryEngine.js";
validateTidalLicense();
export {
  TIDAL_TELEMETRY,
  coverageRootId,
  telemetryEngine
};
//# sourceMappingURL=index.js.map
